export default __webpack_public_path__ + "static/media/inves-app.be4f3b4e.png";